import { Component } from '@angular/core';

@Component({
  selector: 'app-chat-it-tab',
  templateUrl: './chat-it-tab.component.html',
  styleUrls: ['./chat-it-tab.component.scss']
})
export class ChatItTabComponent {

}
